exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton.btn.btn-lg.btn-outline-primary.mr-2[data-v-71182995] {\n    font-size: 14px;\n    padding: 4px 8px;\n    margin-top: 12px;\n}\nbutton.btn-primary[data-v-71182995] {\n    margin-left: 35px;\n    margin-top: 12px;\n}\nbutton.btn.btn-danger[data-v-71182995] {\n    margin-left: 40px;\n    margin-top: 12px;\n}\n", ""]);

// exports
